__turbopack_context__.v({
  "banner": "NotificationBanner-module-scss-module___Urjpq__banner",
  "content": "NotificationBanner-module-scss-module___Urjpq__content",
  "slideDown": "NotificationBanner-module-scss-module___Urjpq__slideDown",
  "wrapper": "NotificationBanner-module-scss-module___Urjpq__wrapper",
});
